import { ActionTree } from 'vuex'
import { State as RootState } from '@/store/state'
import { Settings } from '@/store/settings/state'

export const actions: ActionTree<Settings, RootState> = {}
